import { documentsConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import {
	SharePointTeamSiteListItemViewModel,
	listSites
} from "client/Api/Workspace/LiveInformation/SharePoint/sharePointLiveInformation";

export class SharePointProvider {

	private _pendingListRequest: Promise<readonly SharePointTeamSiteListItemViewModel[]> | null;

	public get isAvailable(): boolean {
		return documentsConfiguration().sharePoint.isConfigured;
	}

	constructor() {
		this._pendingListRequest = null;
	}

	public list(): Promise<readonly SharePointTeamSiteListItemViewModel[]> {
		if (this._pendingListRequest === null) {
			this._pendingListRequest = listSites();
		}

		return this._pendingListRequest;
	}
}
